import { createNamespacer, createReducer } from "../utils/reducers";

const storedLocation = localStorage.getItem("user_location");
const parsedLocation = storedLocation ? JSON.parse(storedLocation) : null;

const initialState = {
  latitude: parsedLocation?.latitude ?? 0,
  longitude: parsedLocation?.longitude ?? 0,
  city: parsedLocation?.city ?? "",
};

const namespacer = createNamespacer("USER_LOCATION");

const handlers = {
  [namespacer("SET_LOCATION")]: (state: any, action: any) => {
    return {
      ...state,
      ...action.payload,
    };
  },
  [namespacer("CLEAR_LOCATION")]: () => {
    return {
      latitude: null,
      longitude: null,
      city: null,
    };
  },
};

const userLocation = createReducer(initialState, handlers, ["USER_LOCATION"]);

export default userLocation;
